
import * as CryptoJS from 'crypto-js';
import { AxiosResponse } from 'axios';
import { API } from '../utils/axios';


export const getUsers = (data: any): Promise<AxiosResponse<any>> => API.get<any>('/user', data);

export const isETFUserValid = (email: string): Promise<AxiosResponse<{exists: boolean}>> => API.get<{exists: boolean}>('/tooluser/is-etf-user-valid?userId=' + email);
export const etfUserLogin = (email: string, password: string): Promise<AxiosResponse<{message: string, data: any, token: string}>> => API.post<{message: string, data: any, token: string}>('/tooluser/etf-login',{email: encryptString(email), password: encryptString(password)});

export const sccUserLogin = (email: string, password: string): Promise<AxiosResponse<{message: string, data: any, token: string}>> => API.post<{message: string, data: any, token: string}>('/tooluser/scc-login',{email: encryptString(email), password: encryptString(password)});
export const isSCCUserValid = (email: string): Promise<AxiosResponse<{exists: boolean}>> => API.get<{exists: boolean}>('/tooluser/is-scc-user-valid?userId=' + email);

export const adminLogin = (email: string, password: string): Promise<AxiosResponse<{error?: string, token?: string}>> => API.post<{error?: string, token?: string}>('/auth/login',{email: email, password: password });


const encryptString = (plainText: string): string => {
    const ciphertext = CryptoJS.AES.encrypt(plainText, '111').toString();
    return ciphertext;
}